import * as React from 'react';

import { PageTitleBar } from 'components';

const ProductsEditHeader = () => (
  <PageTitleBar
    showBackButton={false}
    headerTitle='به‌روزرسانی قیمت محصول‌ها'
  />
);

export { ProductsEditHeader };
